import { Storage } from "common/storage";

const KEY = "pendingVerificationEmail";

/**
 * The address this browser is in the middle of verifying. The link landing page
 * asks the backend to sign in only for it: a verification link opened anywhere
 * else (another device, or a link someone forwarded) verifies and lands on the
 * login step instead of handing the opener a session for that account.
 */
export function rememberPendingVerification(email: string): void {
  Storage.setString(KEY, email.trim().toLowerCase());
}

export function isPendingVerification(email: string): boolean {
  return Storage.getString(KEY) === email.trim().toLowerCase();
}

export function clearPendingVerification(): void {
  Storage.delete(KEY);
}
